<div
    class="notifications-panel-wrapper fade-in"
    (click)="$event.stopPropagation()"
>
    <div class="notifications-panel-title">
        {{ 'Notifications' | transloco }}
        <button
            (click)="close()"
            class="btn-reset-style"
            aria-label="Close notification panel"
        >
            <vsc-icon class="close-panel-icon x-mark-icon"
                >circle-xmark</vsc-icon
            >
        </button>
    </div>
    <div
        class="vsc-card vsc-scrollbar notifications-panel-container"
        fxLayout="column"
    >
        <ng-container *ngIf="notifications$ | async as notifications">
            <ng-container *ngIf="notifications?.length; else noNotifications">
                <ng-container
                    *ngFor="
                        let notification of notifications;
                        trackBy: trackByFn
                    "
                >
                    <vsc-notification-item
                        [item]="notification"
                    ></vsc-notification-item>
                </ng-container>
                <div class="panel-links">
                    <button
                        (click)="markAllAsRead()"
                        class="mark-all-link btn-reset-style"
                    >
                        <vsc-icon
                            [iconStyle]="'solid'"
                            [color]="'accent'"
                            class="vsc-icon flag-icon"
                            >flag</vsc-icon
                        >
                        {{ 'Mark All As Read' | transloco }}
                    </button>
                    <button
                        (click)="redirectAndClose()"
                        class="btn-reset-style"
                    >
                        {{ 'View All Notifications' | transloco }}
                        <vsc-icon
                            [iconStyle]="'solid'"
                            [color]="'accent'"
                            class="vsc-icon"
                            >caret-right</vsc-icon
                        >
                    </button>
                </div>
            </ng-container>
            <ng-template #noNotifications>
                <div
                    class="no-items"
                    fxLayoutAlign="center center"
                    fxLayout="column"
                >
                    <ng-container>
                        <h3>
                            {{ 'There are no notifications' | transloco }}
                        </h3>
                    </ng-container>
                </div>
            </ng-template>
        </ng-container>
    </div>
</div>
